import { flowRight, omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import withTranslate from '../../hoc/with-translate';
import IconButton from '../../components/icon-button';
import NotificationIcon from './notification-icon';
import { getCount } from '../../selectors/notification-selectors';
import styles from './notification-button.scss';

const NotificationButton = ({ bubbleClassName, className, count, t, ...otherProps }) => {
  const bubbleCssClass = classNames(styles.bubble, 'notification-button__bubble', bubbleClassName);

  return (
    <IconButton
      className={classNames('notification-button', className)}
      icon={NotificationIcon}
      label={t('breadcrumbs.notifications')}
      aria-label={t('breadcrumbs.notifications')}
      {...omit(otherProps, 'dispatch')}
    >
      {count ?
        <span className={bubbleCssClass} data-hook="notification-bubble">
          {count}
        </span> :
        null}
    </IconButton>
  );
};

NotificationButton.propTypes = {
  count: PropTypes.number.isRequired,
  bubbleClassName: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  count: getCount(state),
});

export default flowRight(
  connect(mapStateToProps),
  withTranslate,
)(NotificationButton);



// WEBPACK FOOTER //
// ./app/components/notification-button/notification-button.js